function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12z",
  fill: "#2685DB"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.4 10.79c-1.57-.6-2.22-.96-2.22-1.63 0-.38.21-.84 1.22-.84.99 0 2.07.57 2.71.92l.91-1.76c-.6-.38-1.63-.82-2.85-1l-.11-.02V5.19h-2.07v1.3l-.1.02C9.32 6.87 8.3 7.94 8.3 9.25c0 1.64.91 2.65 3.14 3.49 1.03.39 1.78.67 1.78 1.47 0 .71-.54 1.13-1.44 1.13-1.04 0-2.56-.91-3-1.19l-.88 1.91c.99.59 1.96.95 2.99 1.12l.11.02v1.62h2.07v-1.6l.1-.02c1.76-.33 2.94-1.59 2.94-3.13-.01-1.58-.79-2.53-2.71-3.28z",
  fill: "#fff"
});

function SvgUsd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "06f4fe900396615a0412e6bab9dbacce.svg";
export { SvgUsd as ReactComponent };